import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8.4",
  cy: "8.4",
  r: "8.4",
  fill: "#416BA9"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.0386 5.72757C13.2559 5.51585 13.2559 5.17169 13.0386 4.95997C12.822 4.74772 12.4703 4.74772 12.2531 4.95997L6.38956 10.6892L4.55006 8.8924C4.33339 8.68015 3.98116 8.68015 3.76448 8.8924C3.54726 9.10466 3.54726 9.44828 3.76448 9.66L5.96899 11.8146C5.97788 11.8238 5.98621 11.833 5.99566 11.8417C6.104 11.9481 6.24622 12.0008 6.38845 12.0008C6.41512 12.0008 6.44178 11.9992 6.46845 11.9954C6.58345 11.9796 6.69457 11.9286 6.7829 11.8417C6.79235 11.833 6.80124 11.8238 6.80957 11.814L13.0386 5.72757Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };